module.exports = __webpack_public_path__ + "img/crystal@2x.a624233.webp";